<template>
    <table class="table align-items-center table-custom data-table-cards pb-0">
        <thead class="data-table-cards__head">
            <tr>
                <th
                    class="data-table-cards__th"
                    v-for="(heading, hIdx) in tableData.headings"
                    :key="hIdx"
                    :class="hIdx === 0 ? 'pl-3' : ''"
                >
                    <div class="d-flex" v-if="hIdx !== 0">
                        <div class="">{{ heading }}</div>
                    </div>
                    <div v-else>
                        {{ heading }}
                    </div>
                </th>
            </tr>
        </thead>
        <tbody class="data-table-cards__body list">
            <tr
                v-for="(data, index) in tableData.datas"
                :key="index"
                :class="rowCardClass(data)"
                @click="getSlipData(data.voucher)"
            >
                <th
                    scope="row"
                    v-for="(content, cIdx) in tableData.contents"
                    :key="cIdx"
                    class="data-table-cards__td"
                    :class="cIdx === 0 ? 'pl-3' : ''"
                >
                    <div class="media d-flex" v-if="content === 'status'">
                        <span class="mb-0 text-md">
                            <span
                                class="data-table-cards__pill data-table-cards__pill--in"
                                v-if="data[content] === 'in'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေဝင်"
                                }}
                            </span>
                            <span
                                class="data-table-cards__pill data-table-cards__pill--out"
                                v-if="data[content] === 'out'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေထွက်"
                                }}
                            </span>
                        </span>
                    </div>

                    <div class="media align-items-center data-table-cards__cell-text" v-else>
                        <span class="name mb-0 text-md data-table-cards__value">{{
                            (type === "unitList" && content !== "date"
                                ? Number(data[content]).toLocaleString()
                                : data[content]) || '-'
                        }}</span>
                    </div>
                </th>
            </tr>
            <tr
                v-if="type === 'unitList'"
                class="data-table-cards__row data-table-cards__summary"
            >
                <th scope="row" class="pl-3 data-table-cards__td"></th>
                <th scope="row" class="data-table-cards__td">
                    Total -
                    <b class="text-success">{{
                        Number(totalUnitIn()).toLocaleString()
                    }}</b>
                </th>
                <th scope="row" class="data-table-cards__td">
                    Total -
                    <b class="text-success">{{
                        Number(totalUnitOut()).toLocaleString()
                    }}</b>
                </th>
                <th class="data-table-cards__td"></th>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { DateTime } from 'luxon';

export default {
  props: ['tableData', 'type'],
  methods: {
    rowCardClass(data) {
      if (!data || !data.status) return 'data-table-cards__row';
      if (data.status === 'in') return 'data-table-cards__row data-table-cards__row--in';
      if (data.status === 'out') return 'data-table-cards__row data-table-cards__row--out';
      return 'data-table-cards__row';
    },
    getSlipData(voucher) {
      if (voucher) {
        this.$emit('getSlipData', voucher);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    totalUnitIn() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_in, 10);
      }
      return total;
    },
    totalUnitOut() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_out, 10);
      }
      return total;
    },
  },
};
</script>

<style scoped>
.table-custom {
    display: block;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 0;
}

/* Card-style rows: spaced “tiles” instead of a flat grid */
.data-table-cards.table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 10px;
    font-size: 0.8125rem;
    border: none !important;
}

.data-table-cards__head th {
    background: transparent;
    color: #E8C547 !important;
    font-weight: 700;
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    border: none !important;
    padding: 6px 8px 10px;
    white-space: nowrap;
}

.data-table-cards__body tr {
    background: #1E1A32;
    border-radius: 14px;
    border: none !important;
    box-shadow: none;
    transition: background 0.15s ease;
    cursor: pointer;
}

.data-table-cards__body tr:hover {
    background: #2A2640;
    transform: none;
}

.data-table-cards__row--in,
.data-table-cards__row--out {
    box-shadow: none;
}

.data-table-cards__td {
    border: none !important;
    color: #F4F0E8 !important;
    font-weight: 500;
    vertical-align: middle;
    padding: 12px 10px;
}

.data-table-cards__td:first-child {
    border-radius: 14px 0 0 14px;
}

.data-table-cards__td:last-child {
    border-radius: 0 14px 14px 0;
}

.data-table-cards__value {
    color: #FFFFFF !important;
    font-weight: 600;
    font-size: 0.8rem;
}

.data-table-cards__pill {
    display: inline-block;
    font-weight: 700;
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 0.35rem 0.6rem;
    border-radius: 999px;
}

.data-table-cards__pill--in {
    background: rgba(231, 98, 41, 0.18);
    color: #E8C547 !important;
}

.data-table-cards__pill--out {
    background: rgba(91, 58, 140, 0.28);
    color: #FFD54A !important;
}

.data-table-cards__summary {
    cursor: default;
    box-shadow: none !important;
    background: #16122A !important;
    border: none !important;
    outline: none;
}

.data-table-cards__summary:hover {
    transform: none !important;
    box-shadow: none !important;
    background: #2A2640 !important;
}
</style>
